import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ReadyToPostYourFirstRole() {
  return <section data-section-id="223870" id="facility-maintenance-support" className="bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8">
      <div className="relative mx-auto max-w-5xl overflow-hidden rounded-sm bg-secondary px-6 py-20 text-center shadow-xl sm:px-12 sm:py-24">
        {}
        <div className="absolute inset-0 -z-10 flex items-center justify-center opacity-20 mix-blend-overlay pointer-events-none">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/wfh_watermark_logo.png" alt="" className="h-[150%] w-auto object-cover sm:h-auto sm:w-[120%] opacity-30" aria-hidden="true" />
        </div>

        {}
        <div className="relative z-10 flex flex-col items-center">
          <h2 className="font-default text-4xl font-extrabold tracking-wider text-secondary-foreground sm:text-5xl lg:text-6xl uppercase">
            Advanced Tracking & Reporting.
          </h2>
          
          <p className="mt-6 max-w-2xl text-lg text-secondary-foreground/90 font-sans">
            Optimise asset performance with data-driven reporting and reliable maintenance solutions tailored for high-stakes industrial and commercial environments.
          </p>

          <span className="mt-8 font-mono text-xs uppercase tracking-widest text-primary">
            Warehouse & Facility Maintenance Operations Manual
          </span>

          <div className="mt-6 flex w-full flex-col items-center justify-center gap-4 sm:w-auto sm:flex-row">
            <Button asChild size="lg" className="w-full rounded-sm bg-primary text-primary-foreground hover:bg-primary/90 sm:w-auto font-default font-bold text-base h-12 px-8 uppercase tracking-wide">
              <Link to="#">View Sample</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}